module.exports = __webpack_public_path__ + "static/media/pressure-monitor-action-alert.fc0f67f9.svg";